import { useState } from "react";
import "./Anuncio.css"
import img1 from "../../Assets/Images/Logos/Logo_2.png"
const Anuncio = () => {
    const [visible, setVisible] = useState(true);

    const handleClick = () => {
        setVisible(false)
    }

    return (
        visible && (
            <section className="Anuncio">
                <div className="overlay-av" onClick={handleClick}></div>
                <div className="anuncio-content">
                    <div className="sec0-anu">
                        <img src={img1} alt="Legal Capital Corp LLC Logo" />
                    </div>
                    <div className="sec1-anu">
                        <p>
                            Dear <span>Legal Capital Corp LLC</span> clients: Our support and systems team is continuously working 
                            to improve your virtual office experience. New tools, support, and more, along with new features and 
                            <span> top-notch experiences</span>, are coming soon.

                            To improve withdrawal processes, we've updated our application minimums.
                            In the coming hours, you'll be able to see our commitment to improving and managing your finances.
                        </p>
                    </div>
                    <div className="sec2-anu">
                        <p>In the next few hours you will be able to see our commitment to improve and have control of your Finances.</p>
                    </div>
                    <div className="sec3-anu">
                        <p>Atte. Legalcapital Corp LLC</p>
                        <p>support@legalcapital-corp.com</p>
                    </div>
                    <div className="sec4-anu">
                        <button onClick={handleClick} aria-label="Close announcement">
                            <i className="bi bi-x-lg"></i>
                            Close
                        </button>
                    </div>
                </div>
            </section>
        )
    )
}
export default Anuncio